// extracted by mini-css-extract-plugin
module.exports = {"header":"HtmlHeader-module--header--vJTCv","plainHeader":"HtmlHeader-module--plainHeader--2F0WR"};